<template>
  <div class="navbar">
    <div class="navbar-container">
      <div
        v-for="(item, index) in menus"
        :key="index"
        class="navbar-item"
        :class="{ 'navbar-item_active': activeMenu === item.label }"
        @click="$router.push(item.url)"
      >
        {{ item.label }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Navbar',
  components: {},
  props: {
    activeMenu: {},
  },
  data() {
    return {
      menus: [
        { label: '网站首页', url: '/index' },
        { label: '网络演出剧（节）目', url: '/onlineDrama' },
        { label: '相关制度', url: '/relevantNotice' },
        { label: '联系我们', url: '/contact' },
      ],
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="less">
.navbar {
  width: 100%;
  height: 50px;
  background: #0067ac;
}

.navbar-container {
  width: 1200px;
  height: 50px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.navbar-item {
  font-size: 16px;
  color: #ffffff;
  cursor: pointer;
}

.navbar-item:hover {
  color: #e75933;
}

.navbar-item_active {
  color: #e75933;
}
</style>
